import { useDuplicateBreakdownDocument } from '@/hooks/useBreakdownDocuments';
import { NameTagDialog } from './NameTagDialog';

export interface DuplicateDialogProps {
  jobId: string;
  source: { id: string; name: string } | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onDuplicated?: (doc: { id: string; name: string }) => void;
}

// Server-side deep-copy. Unlike Save As, this does NOT navigate to the new
// document — the user stays where they are.
export function DuplicateDialog({
  jobId,
  source,
  open,
  onOpenChange,
  onDuplicated,
}: DuplicateDialogProps) {
  const duplicate = useDuplicateBreakdownDocument(jobId);

  return (
    <NameTagDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Duplicate version"
      description={
        source && (
          <>
            Create a copy of <strong>{source.name}</strong>. The new version
            will not be opened automatically.
          </>
        )
      }
      submitLabel="Duplicate"
      submittingLabel="Duplicating..."
      // Seed with "<source> (copy)" so the common case is one keystroke (Enter).
      initialName={source ? `${source.name} (copy)` : ''}
      onSubmit={async ({ name }) => {
        if (!source) return;
        const doc = await duplicate.mutateAsync({ docId: source.id, name });
        onDuplicated?.({ id: doc.id, name: doc.name });
      }}
    />
  );
}
